import React from "react";
import Link from "gatsby-link";

const SiteTitle = ({ children, language }) => (
  <h1>
    <Link to={`/${language}/`}>{children}</Link>
  </h1>
);

export default SiteTitle;



// WEBPACK FOOTER //
// ./src/components/SiteTitle.js